import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'

import classes from './Secondary.module.scss'

const Secondary = ({ children, className, ...props }) => (
  <Grid item lg={3} md={4} xs={12} className={clsx('Secondary', classes.root, className)} {...props}>
    {children}
  </Grid>
)

export default Secondary
